<template>
  <path pid="0" d="M7.81 24.33h12a3 3 0 003-3v-16a3 3 0 00-3-3h-12a3 3 0 00-3 3v16a3 3 0 003 3zm-1-19a1 1 0 011-1h12a1 1 0 011 1v16a1 1 0 01-1 1h-12a1 1 0 01-1-1z"/><path pid="1" d="M13.81 20.33a5 5 0 10-5-5 5 5 0 005 5zm0-8a3 3 0 11-3 3 3 3 0 013-3z"/>
</template>
